import { useState } from 'react'

import { IconCalendarTime } from '@tabler/icons-react'
import { DatePicker } from 'antd'
import { Moment } from 'moment'
import styled from 'styled-components'

import { BaseButton } from './BaseButton'

import { Button } from '@/components/shared-components/BUI/Button'

const Clear = styled(Button)`
  display: block;
  margin-left: auto;
  margin-top: 0.25rem;
  margin-bottom: 0.125rem;
`

type Props = {
  value?: Moment
  onChange?: (value: Moment) => void
  noValueLabel?: string
}

export const DateDropdown: React.FC<Props> = ({
  value,
  onChange,
  noValueLabel,
}) => {
  const [showDate, toggleShowDate] = useState(false)

  const toggle = () => toggleShowDate((show) => !show)

  const clear = () => {
    onChange(null)
    toggleShowDate(false)
  }

  return (
    <span>
      <DatePicker
        open={showDate}
        onOpenChange={toggleShowDate}
        value={value}
        onChange={onChange}
        style={{ visibility: 'hidden', width: 0, padding: 0 }}
        showToday={false}
        renderExtraFooter={() => (
          <Clear variant="secondary-text" size="small" onClick={clear}>
            Clear
          </Clear>
        )}
      />
      <BaseButton
        hasValue={!!value}
        icon={<IconCalendarTime size={16} />}
        onClick={toggle}
      >
        {value ? value.format('L') : noValueLabel || 'Select date'}
      </BaseButton>
    </span>
  )
}
